import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';
import { TopBar } from '../components/TopBar';
const routeMeta = {
    '/': { section: 'Monitor', title: 'Home' },
    '/executive': { section: 'Monitor', title: 'Executive' },
    '/portfolio': { section: 'Monitor', title: 'Portfolio' },
    '/health': { section: 'Monitor', title: 'Health' },
    '/resources': { section: 'Plan', title: 'Resources' },
    '/ai-recommendations': { section: 'Plan', title: 'AI Insights' },
    '/management-tasks': { section: 'Plan', title: 'Management Tasks' },
    '/approvals': { section: 'Govern', title: 'Approvals' },
    '/reports': { section: 'Govern', title: 'Reports' },
    '/notifications': { section: 'Govern', title: 'Notifications' },
    '/sync': { section: 'Admin', title: 'Sync & Integration' },
    '/admin': { section: 'Admin', title: 'Users & Access' },
};
function getInitialCollapsed() {
    try {
        return localStorage.getItem('sidebar-collapsed') === 'true';
    }
    catch {
        return false;
    }
}
export function AuthenticatedLayout() {
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(getInitialCollapsed);
    const toggleCollapsed = useCallback(() => {
        setCollapsed(prev => {
            const next = !prev;
            try {
                localStorage.setItem('sidebar-collapsed', String(next));
            }
            catch { /* ignore */ }
            return next;
        });
    }, []);
    // Match exact path first, then try prefix match for dynamic routes like /projects/:id
    const meta = routeMeta[location.pathname] ??
        (location.pathname.match(/\/projects\/[^/]+\/planning/) ? { section: 'Plan', title: 'Project Planning' } :
            location.pathname.startsWith('/projects/') ? { section: 'Monitor', title: 'Project Detail' } : { section: '', title: '' });
    return (_jsxs("div", { className: "flex h-screen overflow-hidden", children: [_jsx(Sidebar, { collapsed: collapsed, onToggle: toggleCollapsed }), _jsxs("div", { className: "flex-1 flex flex-col min-w-0", children: [_jsx(TopBar, { sectionLabel: meta.section, pageTitle: meta.title }), _jsx("main", { className: "flex-1 overflow-y-auto bg-surface-muted p-6", children: _jsx(Outlet, {}) })] })] }));
}
//# sourceMappingURL=AuthenticatedLayout.js.map